<div [class]="'app-toast app-toast--' + data.kind" dir="rtl" role="status" aria-live="polite">
  <span class="app-toast__icon material-symbols-outlined" aria-hidden="true">
    {{ iconName }}
  </span>

  <div class="app-toast__body">
    <div class="app-toast__title">{{ data.title }}</div>
    <div class="app-toast__desc" *ngIf="data.description">{{ data.description }}</div>
  </div>

  <button
    type="button"
    class="app-toast__close"
    (click)="close()"
    aria-label="סגור הודעה"
  >
    <span class="material-symbols-outlined" aria-hidden="true">close</span>
  </button>
</div>
